import React from 'react'
import Blog from '../components/Blog';
import About from '../components/About';
import Contact from '../components/Contact';
import Gap from '../components/Gap'

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Home() {
  const location = useLocation()
  const navigate = useNavigate();;

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const targetId = location.state?.targetId;

  useEffect(() => {
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        navigate(location.pathname, { replace: true }); // optional reset
      }
    }
  }, [targetId, location.pathname, navigate]); // ✅ clean dependency list
  
  return (
    <div>
     {/* <Navbar /> */}
      <main>
        <About />
        <Blog />
        <div id="contactus"> 
          <Contact />
        </div>
        <Gap />
      </main>
    </div>
  )
};

export default Home;
